import { type Nullable } from '@Types';
import { type AdmissionOffer } from './AdmissionOffer.types';

export function showFastTrackRegistration(admissionOffer: Nullable<AdmissionOffer>) {
    if (!admissionOffer) return false;
    const fastTrackRegistrationDeadlineTs = admissionOffer.fastTrackRegistrationDeadline;
    if (!fastTrackRegistrationDeadlineTs) return false;

    return Date.now() < 1000 * fastTrackRegistrationDeadlineTs;
}
